import React from "react";

import { Typography } from "@material-ui/core";

import { selectSelectedStore } from "modules/customer/tools/product/productSlice";
import { FootfallMeasureType } from "modules/customer/tools/product/productStoreFit/footfallMeasureType";
import { selectAverageDailyFootfallHeatMapData, selectAverageDailyFootfallMeasure } from "modules/customer/tools/product/productStoreFit/productStoreFitSlice";
import { useAppSelector } from "store";

const AverageDailyFootfallLevel: React.FC = () => {
    const store = useAppSelector(selectSelectedStore);
    const measure = useAppSelector(selectAverageDailyFootfallMeasure);
    const measureLabel = measure === FootfallMeasureType.NumberOfVisits ? "visits" : "dwell time";
    const averageDailyFootfall = useAppSelector(selectAverageDailyFootfallHeatMapData);
    const monthDate = averageDailyFootfall.footfallData[0]?.monthDate ?? null;

    return (
        <Typography variant="subtitle1" component="div" gutterBottom>
            {`Average hourly ${measureLabel} per cell within ${store?.name}'s retail centre (${monthDate?.monthLong} ${monthDate?.year})`}
        </Typography>
    );
};

export default AverageDailyFootfallLevel;
